export default class DescripcionesServicio {

    static materialSolConsCorto(solCons) {
        if (solCons.materialPersonalizado)
            return `${solCons.materialPersonalizado.marca} ${solCons.materialPersonalizado.coleccion}`
        return this.materialSolCons(solCons);
    }

    static materialSolCons(solCons) {
        if (solCons.materialPersonalizado)
            return `${solCons.materialPersonalizado.marca} ${solCons.materialPersonalizado.coleccion} (${solCons.materialDermis.nombre})`
        return  solCons.materialDermis.nombre;
    }

    static descripcionTipoSolCons(codigo) {
        codigo = codigo.toLowerCase();
        switch (codigo) {
            case "horizontal":
            case "vertical":
            case "fachada":
            case "urbano":
                return codigo;
            case "horizontal_rehabilitation":
            case "vertical_rehabilitation":
            case "facade_rehabilitation":
                return codigo.replace("_rehabilitation", "") + " rehabilitación";
        }
        return "";
    }
}